<template lang="pug">
  v-app.bar-and-nav
    v-app-bar(app clipped-left color="#005cb8" flat dark height="56")
      v-app-bar-nav-icon(@click="valueModel=true" v-if="$vuetify.breakpoint.mdAndDown")
      a(href="https://arlingtonva.us").mx-2
        v-img.my-auto(max-height="62" max-width="200" position="top, left" src="CountyLogo_Reverse_Horizontal.png")
      v-spacer
      div.d-inline-block.links
        div(v-for="(link, index) in links").d-inline-block
          v-btn(text color="white" :href="link.url" :title="link.title") {{link.title}}
    v-navigation-drawer(app clipped :mini-variant="mini" :expand-on-hover="mini" v-model="valueModel")
      slot
</template>

<script>
export default {
  props: {
    value: Boolean,
    links: Array,
    mini: Boolean
  },
  computed: {
    valueModel: {
      get: function() {
        return this.value
      },
      set: function(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="stylus">
.top-bar
  .logo
    i
      color: white
      font-size: 39px
    span
      color: white
      font-family: "PT Sans", sans-serif
      font-size: 25px
      font-weight: 600
      margin-left: 8px
  .links
    margin-left: 32px
    overflow-x: scroll
    -ms-overflow-style: none
    scrollbar-width: none
    ::-webkit-scrollbar
      display: none
    white-space: nowrap
    font-size: 16px
    a
      color: white
    .bull
      margin: 8px
</style>